import { C, STROKE, Figure, Label, Leader } from './figureStyle';

const ID = 'fig-udluftning';

const channels = Array.from({ length: 11 }, (_, i) => 24 + i * 14);

export default function UdluftningFigure() {
  return (
    <Figure
      id={ID}
      height={260}
      title="Nærbillede af radiatorens øverste hjørne med en radiatornøgle sat på luftskruen, en klud holdt under skruen og en skål på gulvet, der opsamler vandet."
      caption="Udluftning med radiatornøgle på luftskruen, med en klud under skruen og en skål til at opsamle vandet."
    >
      {/* Radiatorens øverste hjørne */}
      <path
        d="M8,60 H242 Q254,60 254,72 V158 Q254,170 242,170 H8"
        fill={C.page}
        stroke={C.dark}
        strokeWidth={STROKE.outline}
      />
      {channels.map((x) => (
        <line key={x} x1={x} y1="66" x2={x} y2="164" stroke={C.line} strokeWidth={STROKE.secondary} />
      ))}

      {/* Luftskrue med radiatornøgle */}
      <rect x="254" y="74" width="14" height="20" rx="2" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="268" y="79" width="8" height="10" fill={C.light} stroke={C.dark} strokeWidth={STROKE.secondary} />
      <rect x="272" y="76" width="30" height="16" rx="3" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="302" y="50" width="11" height="68" rx="5" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Klud under skruen */}
      <path
        d="M258,104 C268,100 284,101 294,105 C297,118 292,132 296,146 C285,152 268,150 258,146 C262,132 256,118 258,104 Z"
        fill={C.light}
        stroke={C.grey}
        strokeWidth={STROKE.secondary}
      />

      {/* Dråber ned i skålen */}
      <path d="M276,162 q4,6 0,9 q-4,-3 0,-9 Z" fill={C.grey} />
      <path d="M276,182 q4,6 0,9 q-4,-3 0,-9 Z" fill={C.grey} />

      {/* Skål */}
      <path d="M232,206 H320 Q316,240 276,240 Q236,240 232,206 Z" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <line x1="240" y1="222" x2="312" y2="222" stroke={C.grey} strokeWidth={STROKE.secondary} />

      {/* Labels */}
      <Label x={356} y={36} anchor="end" lines={['Radiatornøgle']} />
      <Leader points="307,42 307,48" />
      <Label x={246} y={90} anchor="end" lines={['Luftskrue']} />
      <Label x={306} y={138} lines={['Klud']} />
      <Label x={226} y={230} anchor="end" lines={['Skål']} />
    </Figure>
  );
}
